<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center w-100">
        <span class="subtitle-1 font-weight-bold">
          {{ `${$tc('label.usuario_fornecedor', 1)} - ${$tc('label.tipos_fornecedor.representante_legal', 1)}` }}
        </span>
        <div class="subtitle-2 d-flex align-center" v-if="usuario.statusFluxo">
          <span class="font-weight-bold grey--text text--darken-3 mr-1">
            {{ $t('title.status_aprovacao_juridico') }}:
            <span :style="`color: ${corStatus}`">
              {{ $tc(`status_entidade.${usuario.statusFluxo.toLowerCase()}`, 1) }}
            </span>
          </span>
          <v-tooltip left v-if="usuario.statusFluxo !== 'EM_CADASTRO'">
            <template v-slot:activator="{ on }">
              <v-btn
                text icon
                v-on="on"
                @click="abrirAcompanhamento(usuario)"
              >
                <v-icon >assignment_turned_in</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.acompanhamento_fluxo_aprovacao') }}</span>
          </v-tooltip>
        </div>
      </v-card-title>

      <usuario-fornecedor-dados-pessoais-form
        v-show="isPaginaCarregada"
        ref="usuarioFornecedorDadosPessoaisForm"
        :usuario="usuario"
        :encontrou-omni="encontrouOmni"
        :somente-leitura="somenteLeitura"
        :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor"
        :is-somente-leitura-dados-sensiveis="isSomenteLeituraDadosSensiveis"
        :tenants-usuario="tenantsUsuario"
        @BuscarUsuarioOmni="buscarUsuarioOmni"
        @LimparFormulario="limparFormulario"
      />

      <usuario-fornecedor-configuracoes-acesso-representante-legal-form
        v-show="isPaginaCarregada"
        ref="usuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm"
        :usuario="usuario"
        :encontrou-omni="encontrouOmni"
        :somente-leitura="somenteLeitura"
        :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor"
        :is-somente-leitura-dados-sensiveis="isSomenteLeituraDadosSensiveis"
        :tenants-usuario="tenantsUsuario"
        :is-novo-cadastro="isNovoCadastro"
        :perfis="perfis"
        :grupos-fornecedores="gruposFornecedores"
        :usuario-logado="usuarioLogado"
        :ind-ativo-original="indAtivoOriginal"
        :ind-fluxo-aprovacao-repre-legal="indFluxoAprovacaoRepreLegal"
        :existe-fluxos-impactados-por-inativacao="existeFluxosImpactadosPorInativacao"
        :dados-fluxos-aprovacao-impactados="dadosFluxosAprovacaoImpactados"
        :permissao-solicitar-aprovacao="permissaoSolicitarAprovacao"
        :is-usuario-aprovador="isUsuarioAprovador"
        :ind-cancelando-edicao="indCancelandoEdicao"
        :is-solicitando-aprovacao="isSolicitandoAprovacao"
        :pode-cadastrar-anexos="podeCadastrarAnexos"
        :pode-visualizar-anexos="podeVisualizarAnexos"
        @BuscarGruposFornecedores="buscarGruposFornecedores"
        @abrir-documentacao="abrirDocumentacao"
        @abrir-representacao-conjunto="abrirRepresentacaoConjunto"
        @abrir-modal-fluxos-impactados="abrirModalFluxosImpactadosPorInativacao"
        @confirmar-ativacao-inativo="confirmarAtivacaoInativo"
      />

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!somenteLeitura && podeSolicitarAprovacao"
          dark
          color="red"
          @click.native="preparaDataSolicitarAprovacao"
        >
          {{ $t('label.solicitar_aprovacao') }}
        </v-btn>
        <v-btn
          v-if="podeAprovarRepresentanteLegal"
          dark
          color="primary"
          @click.native="openModalJustificativaAprovacao('APROVADO', $t('label.aprovar'))"
        >
          {{ $t('label.aprovar') }}
        </v-btn>
        <v-btn
          v-if="podeReprovarRepresentanteLegal"
          dark
          color="red"
          @click.native="openModalJustificativaAprovacao('REPROVADO', $t('label.reprovar'))"
        >
          {{ $t('label.reprovar') }}
        </v-btn>
        <v-btn v-if="somenteLeitura" @click.native="cancel">{{ $t('label.voltar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="openCancelarDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="validarSalvar(false)" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="cancelarDialog"
      :title="$t('title.atencao')"
      :message="$t('message.tem_certeza_cancelar')"
      @agree="cancel"
    />

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="dialog.action"
    />

    <usuario-aprovacao-dialog
      ref="modalJustificativaAprovacao"
      :title="titleJustificativaModal"
      :obrigatorio="statusAprovacaoUsuario !== 'APROVADO'"
      @Afirmativo="aprovarReprovarUsuario"
    />

    <confirm
      ref="confirmDialogSolicitarAprovacao"
      :persistent="true"
      :max-width="'600'"
      :agree-label="$t('label.sim')"
      :disagree-label="$t('label.nao')"
    />

    <confirm
      ref="confirmDialogAlterouGrupoFornecedor"
      :message="dialog.content"
      :persistent="true"
      :max-width="'600'"
      @agree="dialog.action"
    />

    <confirm
      ref="avisoAnexoUsuarioAntigoDialog"
      :title="$t('title.atencao')"
      :message="$t('message.aviso_inserir_anexo_obrigatorio_solicitar_aprovacao_usuario')"
      :persistent="true"
      :hide-disagree="true"
      :agree-label="$t('label.ok')"
    />

    <usuario-form-termo-aceite-dialog
      v-if="termoAceite !== null && termoAceite && termoAceite.indAtivo"
      ref="termoAceiteDialog"
      :termo-aceite="termoAceite"
      @Finalizar="finalizar"
    />

    <modal-dados-fluxos-de-aprovacao-impactados-por-inativacao-usuario
      ref="modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario"
      :existe-fluxos-impactados-por-inativacao="existeFluxosImpactadosPorInativacao"
      @disagree="cancelaAcaoInativar"
      @agree="alterarStatusEntidadesImpactadasPorInativacaoUsuario"
    />

    <usuario-data-alteracao-dialog
      ref="modalDataAlteracao"
      :nome-perfil-aprovador-fluxo="usuario.nomePerfilAprovador"
      @CancelarEdicaoData="cancelarEdicaoData"
      @SolicitarAprovacaoEdicaoData="preparaDataSolicitarAprovacao"
    />

    <confirm
      ref="avisoAnexoDialog"
      :title="$t('title.atencao')"
      :message="$t('message.aviso_anexo_obrigatorio')"
      :hide-disagree="true"
      :persistent="true"
      :agree-label="$t('label.ok')"
      @agree="desativarUsuario"
    />

    <acompanhamento
      ref="modalAcompanhamento"
      :fluxo="statusPassos"
      :entidade="'REPRESENTANTE_LEGAL'"
    />
    <v-dialog v-model="dialogAcompanhamentoSemFluxo" max-width="600">
      <v-card>
        <v-card-title class="headline"> {{ $t('label.acompanhamento') }} </v-card-title>
        <v-card-text>
          {{ $t('message.usuario_ativado_sem_fluxo', { perfilAprovador: nomPerfilAprovador, usuarioAprovador: nomUsuarioAprovador}) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { forceHideLoading, forceLoading, skipLoading } from '@/common/functions/loading';
import { copyObject } from '@/common/functions/helpers';
import { enviarEmailAvisoInativacaoFornecedor } from '@/common/resources/workflow-acao';
import Confirm from '@/shared-components/dialog/Confirm';
import Usuario from '@/spa/usuario/Usuario';
import Acompanhamento from '@/shared-components/workflow/Acompanhamento';
import UsuarioAprovacaoDialog from '@/spa/usuario/UsuarioAprovacaoDialog';
import UsuarioFormTermoAceiteDialog from '@/spa/usuario/UsuarioFormTermoAceiteDialog';
import ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario from '@/shared-components/ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario';
import UsuarioFornecedorDadosPessoaisForm from '@/spa/usuario/UsuarioFornecedorDadosPessoaisForm';
import UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm from '@/spa/usuario/UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm';
import UsuarioDataAlteracaoDialog from '@/spa/usuario/UsuarioDataAlteracaoDialog';
import StatusDescricao from '@/shared-components/StatusDescricao';

export default {
  name: 'UsuarioFornecedorRepresentanteLegalForm',
  props: {
    somenteLeitura: Boolean,
    default: false,
    isConversao: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Confirm,
    UsuarioAprovacaoDialog,
    UsuarioFormTermoAceiteDialog,
    ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario,
    UsuarioFornecedorDadosPessoaisForm,
    UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm,
    UsuarioDataAlteracaoDialog,
    StatusDescricao,
    Acompanhamento,
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
      'indAmbienteProdutivo',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
      'getTenantId',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...generateComputed('usr', [
      'canPost',
      'canEdit',
      'canSearch',
      'canAccessCRUD',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isNovoCadastro() {
      return !this.idUsuario && !this.usuario.id;
    },
    desabilitarCadastroFornecedor() {
      return this.isNovoCadastro && !this.buscouOmni;
    },
    isSomenteLeituraDadosSensiveis() {
      return (!this.isNovoCadastro || this.encontrouOmni) && this.tenantsUsuario && (this.tenantsUsuario.length > 1
        || (this.tenantsUsuario.length === 1 && this.tenantsUsuario[0].toUpperCase() !== this.chaveEmpresa));
    },
    usuarioLogadoFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    usuarioLogadoFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    isSomenteLeitura() {
      return this.somenteLeitura;
    },
    isUsuarioAprovador() {
      return this.usuarioLogado.idPerfil === this.idPerfilAprovador;
    },
    idsGruposOriginais() {
      return (this.gruposFornecedoresOriginais || []).map((g) => g.id).sort();
    },
    idsGruposSelecionados() {
      return this.listaGrupoFornecedoresSelecionados.map((g) => g.id).sort();
    },
    isGrupoFornecedorAlterado() {
      if (this.isNovoCadastro) return false;
      if (this.idsGruposOriginais.length !== this.idsGruposSelecionados.length) return true;
      return this.idsGruposOriginais.join(',') !== this.idsGruposSelecionados.join(',');
    },
    isDtaFinalMenorQueDtaAtual() {
      return this.usuario.indProcurador && !this.isDataNaoVencida() && this.usuario.indAtivo && this.isUsuarioAprovador;
    },
    podeVisualizarAnexos() {
      return this.canSearch;
    },
    podeCadastrarAnexos() {
      return this.canAccessCRUD && this.usuarioLogadoFuncionario;
    },
    permissaoSolicitarAprovacao() {
      if (!this.getAllRoles) return false;
      return !!this.getAllRoles.filter((el) => el === 'SOLICITAR_APROVACAO_USUARIO').length;
    },
    podeSolicitarAprovacao() {
      // Permite solicitação se o status for diferente dos bloqueados,
      // ou se o usuário APROVADO estiver inativo (vigência expirada pelo Job)
      const statusPermiteAprovacao = this.usuario.statusFluxo
        ? (!['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(this.usuario.statusFluxo)
            && (this.usuario.statusFluxo !== 'APROVADO' || !this.usuario.indAtivo))
        : this.usuario.id;

      return !!statusPermiteAprovacao
        && this.permissaoSolicitarAprovacao
        && !this.usuario.indAtivo
        && !this.isGrupoFornecedorAlterado
        && !this.isUsuarioAprovador
        && !this.indAtivoOriginal;
    },
    podeAprovarRepresentanteLegal() {
      return this.isUsuarioAprovador
        && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(this.usuario.statusFluxo)
        && this.todosOsGruposPossuemAnexos();
    },
    podeReprovarRepresentanteLegal() {
      return this.isUsuarioAprovador
        && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(this.usuario.statusFluxo);
    },
    listaGrupoFornecedoresSelecionados() {
      const ref = this.$refs && this.$refs.usuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm;
      return (ref && ref.listaGrupoFornecedores) ? ref.listaGrupoFornecedores : [];
    },
    indAprovadoAExpirar() {
      return this.usuario.statusFluxo === 'APROVADO' && this.isDtaFinalMenorQueDtaAtual;
    },
    isDataAlterada() {
      const dtaInicio = this.moment(this.usuario.dtaInicioVigencia, 'YYYY-MM-DD');
      const dtaFim = this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
      const dtaInicioOriginal = this.moment(this.dtaInicioVigenciaOriginal, 'YYYY-MM-DD');
      const dtaFimOriginal = this.moment(this.dtaFimVigenciaOriginal, 'YYYY-MM-DD');
      return !dtaInicio.isSame(dtaInicioOriginal) || !dtaFim.isSame(dtaFimOriginal);
    },
    isDataInicioVigenciaAlterada() {
      const dtaInicio = this.moment(this.usuario.dtaInicioVigencia, 'YYYY-MM-DD');
      const dtaInicioOriginal = this.moment(this.dtaInicioVigenciaOriginal, 'YYYY-MM-DD');
      return !dtaInicio.isSame(dtaInicioOriginal);
    },
    podeInativarUsuario() {
      return this.usuario.statusFluxo === 'APROVADO' && !this.usuario.indAtivo && this.isUsuarioAprovador;
    },
    corStatus() {
      let colorIndex = 4;
      switch (this.usuario.statusFluxo) {
        case 'APROVADO':
          colorIndex = 0;
          break;
        case 'EM_ANALISE':
          colorIndex = 3;
          break;
        case 'CANCELADO':
          colorIndex = 3;
          break;
        case 'AGUARDANDO_APROVACAO':
          colorIndex = 2;
          break;
        case 'REPROVADO':
          colorIndex = 1;
          break;
        default:
          colorIndex = 4;
      }
      return this.colorPalette[colorIndex];
    },
  },
  data() {
    return {
      usuarioResource: this.$api.usuario(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      workflowApuracaoAcaoResource: this.$api.workflowApuracaoAcao(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      usuario: new Usuario(null, 'FORNECEDOR'),
      perfis: [],
      gruposFornecedores: [],
      gruposFornecedoresOriginais: [],
      gruposFornecedoresSelecionados: [],
      indTodosGruposPossuemAnexosCarregamentoPagina: false,
      indCancelandoEdicao: false,
      tenantsUsuario: null,
      encontrouOmni: false,
      buscouOmni: false,
      isPaginaCarregada: false,
      idUsuario: null,
      indAtivoOriginal: false,
      indHabilitaAlterarFluxosImpactados: false,
      existeFluxosImpactadosPorInativacao: false,
      existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo: false,
      indMudouTipoUsuario: false,
      dadosFluxosAprovacaoImpactados: {},
      statusParaSalvar: null,
      loginAntigo: '',
      idPerfilAprovador: null,
      indFluxoAprovacaoRepreLegal: false,
      desabilitaFluxoAprovacaoUsuarioInativo: false,
      termoAceite: null,
      existeTermoAceite: false,
      listaAceitesParaSalvar: [],
      listaIdsGruposComAceite: [],
      dtaInicioVigenciaOriginal: null,
      dtaFimVigenciaOriginal: null,
      dataApagada: false,
      dialogAcompanhamentoSemFluxo: false,
      nomPerfilAprovador: '',
      nomUsuarioAprovador: '',
      statusPassos: {},
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      titleJustificativaModal: '',
      statusAprovacaoUsuario: null,
      statusAprovadoRepresentanteLegal: null,
      justificativaAprovacaoReprovacaoUsuario: null,
      isSolicitandoAprovacao: false,
      usuarioSemEdicao: null,
      colorPalette: [
        '#1abc9c', // Verde
        '#e74c3c', // Vermelho
        '#e67e22', // Laranja
        '#f1c40f', // Amarelo
        '#000000', // Preto
      ],
    };
  },
  methods: {
    ...mapActions('metadados', [
      'setUsuarioMetadado',
    ]),
    abrirModalFluxosImpactadosPorInativacao(dados) {
      setTimeout(() => this.$refs.modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.open(dados), 2E2);
    },
    buscaDadosFluxosAprovacaoImpactados(idUsuario) {
      this.usuarioResource.dadosFluxosAprovacaoImpactados({ idUsuario })
        .then((res) => {
          this.dadosFluxosAprovacaoImpactados = res.body;
          if (Object.keys(this.dadosFluxosAprovacaoImpactados).length > 0) {
            const d = this.dadosFluxosAprovacaoImpactados;
            d.idsCampanha = d.idsCampanha && d.idsCampanha.length ? d.idsCampanha.split(',').map(Number) : [];
            d.idsApuracao = d.idsApuracao && d.idsApuracao.length ? d.idsApuracao.split(',').map(Number) : [];
            d.idsContrato = d.idsContrato && d.idsContrato.length ? d.idsContrato.split(',').map(Number) : [];
            d.idsContratoRepresentacaoConjunto = d.idsContratoRepresentacaoConjunto && d.idsContratoRepresentacaoConjunto.length
              ? d.idsContratoRepresentacaoConjunto.split(',').map(Number) : [];
            if (d.idsCampanha.length > 0 || d.idsApuracao.length > 0
              || d.idsContrato.length > 0 || d.idsContratoRepresentacaoConjunto.length > 0) {
              this.existeFluxosImpactadosPorInativacao = true;
            }
          }
        })
        .catch((err) => { this.$toast(err.data.error); });
    },
    buscaTermoAceiteUsuarioCadastro(idUsuario) {
      this.usuarioResource.buscaTermoAceiteUsuarioCadastro({ idUsuario })
        .then((res) => { this.existeTermoAceite = res.body; })
        .catch((err) => { this.$toast(err.data.error); });
    },
    buscarAceitesExistentes(idUsuario, idsGruposCadastrados) {
      const params = {
        idUsuario,
        tipoTermo: 'termoNomeacao',
        tipoUsuario: 'REPRESENTANTE_LEGAL',
        idsGruposCadastrados,
      };
      this.termoAceiteResources.buscarAceitesUsuarioPorGrupo(params)
        .then((response) => {
          const aceites = response.data || [];
          this.listaIdsGruposComAceite = aceites
            .map((a) => a.id_grupo_fornecedor)
            .filter((id) => id !== null && id !== undefined);
        })
        .catch((err) => { console.error('Erro ao buscar aceites existentes', err); });
    },
    // ─── Impactos de workflow ─────────────────────────────────────────────────────
    cancelaAcaoInativar() {
      this.usuario.indAtivo = true;
      this.indMudouTipoUsuario = false;
    },
    alterarStatusEntidadesImpactadasPorInativacaoUsuario(justificativa, indReprovacaoUsuarioFornecedorMaster) {
      if (!this.$refs.form.validate()) return;
      this.indHabilitaAlterarFluxosImpactados = true;
      if (indReprovacaoUsuarioFornecedorMaster) {
        this.justificativaAprovacaoReprovacaoUsuario = justificativa;
        this.save('REPROVADO');
      } else {
        this.save();
      }
    },
    pegaDataAtual() {
      const dataAtual = new Date();
      const options = {
        day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: '2-digit',
      };
      return dataAtual.toLocaleString('pt-BR', options);
    },
    enviarAcoesParaAnalise() {
      const listaAcoes = this.dadosFluxosAprovacaoImpactados.idsCampanha || [];
      const horaInativacao = this.pegaDataAtual();
      const promises = listaAcoes.map((idAcao) => {
        const params = {
          idAcao,
          observacao: this.isGrupoFornecedorAlterado
            ? this.$t('message.enviado_analise_automaticamente_por_alteracao_grupo_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao })
            : this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
        };
        return this.workflowAcaoResource.enviarAnaliseAcaoPorInativacaoFornecedor(params, params)
          .catch((err) => { this.$error(this, err); });
      });
      return Promise.all(promises);
    },
    enviarApuracoesParaAnalise() {
      const listaApuracoes = this.dadosFluxosAprovacaoImpactados.idsApuracao || [];
      const horaInativacao = this.pegaDataAtual();
      const promises = listaApuracoes.map((idApuracao) => {
        const params = {
          idApuracao,
          observacao: this.isGrupoFornecedorAlterado
            ? this.$t('message.enviado_analise_automaticamente_por_alteracao_grupo_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao })
            : this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
        };
        return this.workflowApuracaoAcaoResource.enviarAnaliseApuracaoPorInativacaoFornecedor(params, params)
          .catch((err) => { this.$error(this, err); });
      });
      return Promise.all(promises);
    },
    enviarContratosParaAnalise() {
      const listaContratos = this.dadosFluxosAprovacaoImpactados.idsContrato || [];
      const horaInativacao = this.pegaDataAtual();
      const promises = listaContratos.map((idContrato) => {
        const params = {
          idContrato,
          observacao: this.isGrupoFornecedorAlterado
            ? this.$t('message.enviado_analise_automaticamente_por_alteracao_grupo_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao })
            : this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
        };
        return this.workflowContratoResource.enviarAnaliseContratoPorInativacaoFornecedor(params, params)
          .catch((err) => { this.$error(this, err); });
      });
      return Promise.all(promises);
    },
    enviarContratosRepresentacaoConjuntoParaAnalise() {
      const listaContratos = this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto || [];
      const horaInativacao = this.pegaDataAtual();
      const promises = listaContratos.map((idContrato) => {
        const params = {
          idContrato,
          justificativa: this.$t('message.enviado_analise_automaticamente_por_alteracao_grupo_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
        };
        return this.workflowContratoResource.enviaAnaliseContratoPorAlteracaoGrupoFornecedor(params, params)
          .catch((err) => { this.$error(this, err); });
      });
      return Promise.all(promises);
    },
    enviaEmailAvisoInativacao() {
      const params = {
        listaCampanhas: this.dadosFluxosAprovacaoImpactados.idsCampanha,
        listaApuracoes: this.dadosFluxosAprovacaoImpactados.idsApuracao,
        listaContratos: this.dadosFluxosAprovacaoImpactados.idsContrato,
        idUsuario: this.idUsuario,
      };
      enviarEmailAvisoInativacaoFornecedor(params, this.$resource)
        .catch((err) => { this.$error(this, err); });
    },
    isDataNaoVencida() {
      if (this.usuario.dtaFimVigencia) {
        const hoje = this.moment();
        const dtFinal = this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
        return dtFinal.isSameOrAfter(hoje);
      }
      return false;
    },
    confirmarAtivacaoInativo() {
      this.$refs.confirmDialogSolicitarAprovacao.openWithParams(
        this.$t('title.atencao'),
        this.$t('message.solicitar_aprovacao_usuario'),
        (ok) => {
          if (ok) {
            this.preparaDataSolicitarAprovacao();
          }
        },
      );
    },
    validarSalvar() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.listaGrupoFornecedoresSelecionados
        && !this.listaGrupoFornecedoresSelecionados.length) {
        this.$toast(this.$t('message.grupo_fornecedor_obrigatorio'));
        return;
      }
      if (this.usuario.ehEdicao() && this.isGrupoFornecedorAlterado) {
        const idsSelecionados = this.idsGruposSelecionados;
        const removidos = this.gruposFornecedoresOriginais.filter(
          (grupoOriginal) => !idsSelecionados.includes(grupoOriginal.id),
        );
        const foiRemovidoUmGrupoComRep = removidos.some(
          (grupoRemovido) => grupoRemovido.indPossuiRepresentacaoConjunto === true,
        );
        if (foiRemovidoUmGrupoComRep) {
          this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo = true;
          this.abrirModalConfirmacaoInativarGrupoRepConjunto(removidos);
          return;
        }
      }
      this.validarGrupoFornecedorAlterado();
    },
    abrirModalConfirmacaoInativarGrupoRepConjunto(gruposRemovidos, ref, from) {
      const nomesRemovidos = gruposRemovidos
        .map((grupo) => grupo.nomExtensao)
        .filter((nome) => nome)
        .join(', ');
      const content = this.$t('message.aviso_alteracao_grupos_fornecedor_usr_com_grupos_rep', { nomesRemovidos });
      this.setDialogContent(
        content,
        () => { this.validarGrupoFornecedorAlterado(ref, from); },
        from || this.dialog.from,
      );
      this.$refs.confirmDialogAlterouGrupoFornecedor.open();
    },
    validarGrupoFornecedorAlterado(ref, from) {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.isDtaFinalMenorQueDtaAtual) {
        this.usuario.indAtivo = false;
        this.panelKey += 1;
        this.$toast(this.$t('errors.data.final_menor_data_atual'));
      }
      if (this.indFluxoAprovacaoRepreLegal
          && this.permissaoSolicitarAprovacao && this.isGrupoFornecedorAlterado && !this.isUsuarioAprovador) {
        this.panelKey += 1;
        this.abrirModalConfirmacaoAlteracaoGrupo(ref, from);
      } else {
        this.resetaStatusParaSalvar();
        this.openSaveDialog(ref, from);
      }
    },
    async abrirModalConfirmacaoAlteracaoGrupo(ref, from) {
      const indAtivoOriginal = this.usuario.indAtivo;
      const idsOriginais = this.idsGruposOriginais;
      const idsSelecionados = this.idsGruposSelecionados;
      const idsAdicionados = idsSelecionados.filter((id) => !idsOriginais.includes(id));
      const idsRemovidos = idsOriginais.filter((id) => !idsSelecionados.includes(id));
      const indInativacaoForcada = this.indAtivoOriginal && idsAdicionados.length > 0;
      const idsParaVerificarImpacto = indInativacaoForcada ? idsOriginais : idsRemovidos;

      let entidadesImpactadas = {};
      if (idsParaVerificarImpacto.length > 0) {
        try {
          const response = await this.usuarioResource.verificarImpactoRemocaoGrupos(
            { idUsuario: this.usuario.id },
            idsParaVerificarImpacto,
          );
          entidadesImpactadas = response.body;
        } catch (e) {
          this.$error(this, e);
          return;
        }
      }

      let mensagem = '';

      if (idsAdicionados.length > 0) {
        const nomesAdicionados = this.gruposFornecedoresOriginais
          .filter((grupo) => idsAdicionados.includes(grupo.id))
          .map((grupo) => grupo.nome)
          .join(', ');
        let key;
        if (idsAdicionados.length === 1) {
          key = this.indAtivoOriginal ? 'inclusaoGrupoFornecedorIndAtivo' : 'inclusaoGrupoFornecedorIndInativo';
        } else {
          key = this.indAtivoOriginal ? 'inclusaoGruposFornecedoresIndAtivo' : 'inclusaoGruposFornecedoresIndInativo';
        }
        mensagem += `<br />${this.$t(`message.${key}`, { nomesAdicionados })}`;
      }

      const isFluxosImpactados = entidadesImpactadas && (
        entidadesImpactadas.quantidadeCampanha > 0
        || entidadesImpactadas.quantidadeApuracao > 0
        || entidadesImpactadas.quantidadeContrato > 0
        || entidadesImpactadas.quantidadeContratoRepresentacaoConjunto > 0
      );

      if (isFluxosImpactados) {
        const idsReaisImpactados = entidadesImpactadas.idsGruposComImpacto
          ? entidadesImpactadas.idsGruposComImpacto.split(',').map(Number)
          : [];
        const nomesImpactados = this.gruposFornecedoresOriginais
          .filter((grupo) => idsReaisImpactados.includes(grupo.id))
          .map((grupo) => grupo.nome)
          .join(', ');
        const keyMensagem = idsReaisImpactados.length === 1 ? 'exclusaoGrupoFornecedor' : 'exclusaoGruposFornecedor';
        mensagem += `${this.$t(`message.${keyMensagem}`, { nomesRemovidos: nomesImpactados })}`;
      }

      if (idsAdicionados.length > 0) {
        mensagem += `${this.$t('message.deseja_solicitar_aprovacao')}`;
      } else if (isFluxosImpactados && idsAdicionados.length === 0) {
        mensagem += `${this.$t('message.salvar_usuario')}`;
        mensagem += `${this.$t('message.afirmativaExclusaoGrupoFornecedor')}`;
      }

      if (idsRemovidos.length > 0 && idsAdicionados.length === 0 && !isFluxosImpactados) {
        this.usuario.indAtivo = indAtivoOriginal;
        this.setDialogContent(this.$t('message.salvar_usuario'), this.save, from || this.dialog.from);
        this.$refs.confirmDialog.open();
      } else {
        this.$refs.confirmDialogSolicitarAprovacao.openWithParams(this.$t('title.atencao'), mensagem, (confirmou) => {
          if (confirmou) {
            this.dadosFluxosAprovacaoImpactados.idsCampanha = entidadesImpactadas.idsCampanha ? entidadesImpactadas.idsCampanha.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsApuracao = entidadesImpactadas.idsApuracao ? entidadesImpactadas.idsApuracao.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContrato = entidadesImpactadas.idsContrato ? entidadesImpactadas.idsContrato.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto = entidadesImpactadas.idsContratoRepresentacaoConjunto
              ? entidadesImpactadas.idsContratoRepresentacaoConjunto.split(',').map(Number) : [];
            if (isFluxosImpactados) {
              this.existeFluxosImpactadosPorInativacao = true;
              this.indHabilitaAlterarFluxosImpactados = true;
            }
            if (idsAdicionados.length > 0) {
              if (!this.todosOsGruposPossuemAnexos()) {
                this.usuario.indAtivo = indAtivoOriginal;
                this.$refs.avisoAnexoUsuarioAntigoDialog.open();
              } else {
                this.usuario.indAtivo = false;
                this.statusParaSalvar = 'AGUARDANDO_APROVACAO';
                this.preparaDataSolicitarAprovacao();
              }
            } else {
              this.statusParaSalvar = null;
              this.save();
            }
          } else {
            this.usuario.indAtivo = indAtivoOriginal;
          }
        });
      }
    },
    resetaStatusParaSalvar() {
      this.statusParaSalvar = null;
    },
    openSaveDialog(ref, from) {
      if (!this.$refs.form.validate()) return;

      // Validação 1: Verificar anexo obrigatório
      if (this.podeCadastrarAnexos && !this.todosOsGruposPossuemAnexos()
          && this.usuario.indAtivo) {
        this.$refs.avisoAnexoDialog.open();
        return;
      }

      // Validação 2: Verificar alteração de datas para procurador
      if (!this.isNovoCadastro && this.usuario.indProcurador && this.isDataAlterada && !this.isUsuarioAprovador) {
        this.openModalAlteracaoData();
        return;
      }

      const content = this.$t('message.salvar_usuario');
      this.setDialogContent(content, this.save, from || this.dialog.from);
      this.$refs.confirmDialog.open();
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_usuario');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    finalizar(listaDeAceites) {
      this.listaAceitesParaSalvar = listaDeAceites;
      this.setDialogContent(null, this.save, this.dialog.from);
      this.$refs.confirmDialog.open();
    },
    // ─── Solicitação de Aprovação (Refatorada) ────────────────────────────────────
    preparaDataSolicitarAprovacao() {
      this.isSolicitandoAprovacao = true;
      let dataAlterada = false;

      if (this.indAprovadoAExpirar) {
        if (this.usuario.indProcurador) {
          this.dataApagada = true;
        } else {
          dataAlterada = true;
        }
      }

      this.$nextTick(() => {
        setTimeout(() => {
          this.openSolicitarAprovacaoDialog(dataAlterada);
        });
      });
    },
    openSolicitarAprovacaoDialog(dataAlterada = false) {
      if (!this.todosOsGruposPossuemAnexos()) {
        this.$refs.avisoAnexoUsuarioAntigoDialog.open();
      } else {
        if (!this.$refs.form.validate()) {
          this.isSolicitandoAprovacao = false;
          return;
        }
        this.save('AGUARDANDO_APROVACAO', dataAlterada);
      }
    },
    openModalJustificativaAprovacao(status, titleModal) {
      if (this.isUsuarioAprovador && status === 'REPROVADO'
        && this.indAtivoOriginal && this.existeFluxosImpactadosPorInativacao) {
        const dados = {
          idUsuario: this.usuario.id,
          nomeFornecedor: this.usuario.nomeSobrenome,
          dadosFluxosAprovacaoImpactados: this.dadosFluxosAprovacaoImpactados,
          indReprovacaoUsuarioFornecedorMaster: true,
        };
        setTimeout(() => this.$refs.modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.open(dados), 2E2);
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      this.titleJustificativaModal = titleModal;
      this.statusAprovacaoUsuario = status;
      this.statusAprovadoRepresentanteLegal = status;
      this.$refs.modalJustificativaAprovacao.open();
    },
    aprovarReprovarUsuario(justificativa) {
      this.justificativaAprovacaoReprovacaoUsuario = justificativa;
      this.save(this.statusAprovadoRepresentanteLegal);
    },

    definirStatusFluxo(statusFluxo) {
      let statusFinal = statusFluxo;

      if (this.statusParaSalvar !== null) {
        statusFinal = this.statusParaSalvar;
      } else if (statusFluxo === null && (this.podeInativarUsuario || (this.isNovoCadastro && this.isUsuarioAprovador))) {
        statusFinal = 'EM_CADASTRO';
      } else if (statusFluxo === 'REPROVADO') {
        // Já é REPROVADO, mantém como está
        statusFinal = 'REPROVADO';
      } else if (statusFluxo === null && this.usuario.statusFluxo === 'APROVADO' && this.isUsuarioAprovador) {
        statusFinal = this.usuario.statusFluxo;
        // Se quem ta salvando é o aprovador, o fornecedor ja nasce ativo
      } else if (statusFluxo === null && this.usuario.indAtivo && this.isUsuarioAprovador) {
        statusFinal = 'APROVADO';
      }

      return statusFinal;
    },
    processarDatasVigencia(objArmazenamento, statusFluxo, dataAlterada) {
      const isReativacao = !this.indAtivoOriginal && this.usuario.indAtivo;
      if (this.isNovoCadastro && this.usuario.indProcurador) {
        objArmazenamento.dtaInicioVigenciaPrevia = this.usuario.dtaInicioVigencia;
        objArmazenamento.dtaFimVigenciaPrevia = this.usuario.dtaFimVigencia;
      } else if (statusFluxo === 'APROVADO') {
        // Quando aprovando, define as datas de vigência
        objArmazenamento.dtaInicioVigencia = dataAlterada
          ? this.usuario.dtaInicioVigencia
          : this.dtaInicioVigenciaOriginal;
        objArmazenamento.dtaFimVigencia = this.usuario.dtaFimVigencia;

        if (this.usuario.indProcurador && this.isDtaFinalMenorQueDtaAtual) {
          objArmazenamento.dtaInicioVigenciaPrevia = this.dtaInicioVigenciaOriginal;
          objArmazenamento.dtaFimVigenciaPrevia = this.dtaFimVigenciaOriginal;
        }
      } else if (isReativacao) {
        // Se está reativando, pode alterar datas
        objArmazenamento.dtaInicioVigencia = this.usuario.dtaInicioVigencia;
        objArmazenamento.dtaFimVigencia = this.usuario.dtaFimVigencia;
      }
    },
    montarObjetoArmazenamento() {
      const lista = this.listaGrupoFornecedoresSelecionados || [];
      const listaIdsGrupoFornecedor = lista.length > 0 ? lista.map((item) => parseInt(item.id, 10)) : [];

      return {
        ...this.usuario,
        tenant: this.getTenantId,
        grupofornecedor: lista,
        id_grupofornecedor: listaIdsGrupoFornecedor,
      };
    },
    save(statusFluxo = null, dataAlterada = false) {
      this.aplicarTrimCamposTexto();

      const objArmazenamento = this.montarObjetoArmazenamento();
      const statusFinal = this.definirStatusFluxo(statusFluxo);

      if (statusFinal === 'REPROVADO') {
        objArmazenamento.indAtivo = false;
      }

      this.processarDatasVigencia(objArmazenamento, statusFinal, dataAlterada);

      objArmazenamento.statusFluxo = statusFinal;
      objArmazenamento.justificativaAprovacao = this.justificativaAprovacaoReprovacaoUsuario;
      objArmazenamento.indUsuarioExternoMaster = true;
      objArmazenamento.dataAlterada = dataAlterada || null;
      objArmazenamento.isGrupoFornecedorAlterado = this.isGrupoFornecedorAlterado;

      this.exibeAlertaLgpd();
      forceLoading();

      if (this.isNovoCadastro) {
        this.requestGravar(objArmazenamento, this.usuarioResource.gravar);
      } else {
        this.requestAtualizar(objArmazenamento, this.usuarioResource.atualizar);
      }
    },
    exibeAlertaLgpd() {
      if (this.indAmbienteProdutivo) return;
      const alertaLgpd = this.$t('message.lgpd');
      alert(alertaLgpd); // eslint-disable-line
    },
    aplicarTrimCamposTexto() {
      this.usuario.nomUsuario = this.usuario.nomUsuario.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      this.usuario.email = this.usuario.email.trim();
      this.usuario.nome = this.usuario.nome.trim();
      if (this.usuario.matricula) {
        this.usuario.matricula = this.usuario.matricula.trim();
      }
      if (this.usuario.sobrenome) {
        this.usuario.sobrenome = this.usuario.sobrenome.trim();
      }
      if (this.usuario.cargo) {
        this.usuario.cargo = this.usuario.cargo.trim();
      }
      if (this.usuario.documento) {
        this.usuario.documento = this.usuario.documento.trim();
      }
    },
    requestAtualizar(object, resource) {
      resource({ id: object.id }, object)
        .then(() => {
          if (this.existeFluxosImpactadosPorInativacao) {
            if (this.indHabilitaAlterarFluxosImpactados && this.desabilitaFluxoAprovacaoUsuarioInativo) {
              skipLoading();
              Promise.all([
                this.enviarAcoesParaAnalise(),
                this.enviarApuracoesParaAnalise(),
                this.enviarContratosParaAnalise(),
              ]).then(() => {
                this.enviaEmailAvisoInativacao();
                this.dadosFluxosAprovacaoImpactados = [];
                this.indHabilitaAlterarFluxosImpactados = false;
              });
            }
            if (this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo) {
              Promise.all([
                this.enviarContratosRepresentacaoConjuntoParaAnalise(),
              ]).then(() => {
                this.dadosFluxosAprovacaoImpactados = [];
                this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo = false;
              });
            }
          }
          this.indCancelandoEdicao = false;
          forceHideLoading();
          window.setTimeout(() => {
            this.$router.push({ name: 'usuario-fornecedor' });
            this.$toast(this.$t('message.atualizado_com_sucesso'));
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    requestGravar(object, resource) {
      resource(object)
        .then((res) => {
          this.usuario.id = res.data;
          this.loginAntigo = '';
          window.setTimeout(() => {
            this.indCancelandoEdicao = false;
            forceHideLoading();
            if (this.podeCadastrarAnexos) {
              this.editUsuario(this.usuario.id);
            } else {
              this.$router.push({ name: 'usuario-fornecedor' });
              this.$toast(this.$t('message.adicionado_confira_tabela'));
            }
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          if (err.bodyText && JSON.parse(err.bodyText).erros
            && (JSON.parse(err.bodyText).erros[0] === 'login.duplicado'
              || JSON.parse(err.bodyText).erros[0] === 'omni.usuario.nom_usuario.already_exists')) {
            this.loginAntigo = this.usuario.nomUsuario;
            this.$refs.form.validate();
          }
          this.$toast(err.data.error);
        });
    },
    editUsuario(id) {
      const tipoFornecedor = 'REPRESENTANTE_LEGAL';
      this.$router.push({ name: 'editarUsuarioFornecedorNovo', params: { id }, query: { tipoFornecedor } });
      window.setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    buscarUsuarioOmni() {
      const { tipo, email } = this.usuario;
      const filtro = { tipo, email };
      this.usuario.indUsuarioExternoMaster = true;
      this.usuario.indAtivo = false;
      this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.representante_legal');
      this.usuario.indProcurador = false;
      this.usuarioResource.buscarNoOmni(filtro)
        .then((res) => {
          const usuarioOmni = res.data;
          const inativarUsuario = true;
          this.usuario.construirAPartirUsuarioOmni(usuarioOmni, inativarUsuario);
          this.tenantsUsuario = res.data.tenants.map((t) => t.tenant);
          this.usuario.indOrigemOmni = true;
          this.encontrouOmni = true;
          this.buscouOmni = true;
        })
        .catch((err) => {
          if (err.bodyText && JSON.parse(err.bodyText).erros
              && JSON.parse(err.bodyText).erros[0] === 'usuario.email_invalido') {
            this.buscouOmni = false;
            this.$error(this, err);
          } else {
            this.usuario.nomUsuario = this.usuario.email;
            this.buscouOmni = true;
            this.$error(this, err);
          }
        });
    },
    buscarPerfis(content = '') {
      const params = {
        autocomplete: content,
        limit: 1000,
        page: 0,
      };
      return this.perfilResource.selecao(params)
        .then((res) => {
          if (res.data) {
            this.perfis = res.data.filter((perfil) => {
              perfil.indPerfilUsuarioExterno = this.converterStringParaBoolean(perfil.indPerfilUsuarioExterno);
              return perfil.indPerfilUsuarioExterno;
            });
          }
          this.selecionarPerfilAuto();
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    selecionarPerfilAuto() {
      if (this.usuarioLogadoFornecedor) {
        this.usuario.idPerfil = this.usuarioLogado.idPerfil;
      } else if (this.perfis.length === 1) {
        this.usuario.idPerfil = this.perfis[0].id;
      }
    },
    converterStringParaBoolean(perfil) {
      return String(perfil).toLowerCase() === 'true';
    },
    buscaDadosPerfilAprovador() {
      return this.perfilResource.buscaIdPerfilUsuarioAprovador()
        .then((res) => {
          this.idPerfilAprovador = res.data;
        });
    },
    buscarGruposFornecedores(idGrupoFornecedor = null, filtro = null) {
      let idsBusca = [];
      this.gruposFornecedoresSelecionados = [];
      this.gruposFornecedores = [];
      if (Array.isArray(idGrupoFornecedor)) {
        idsBusca = idGrupoFornecedor;
      } else {
        idsBusca = idGrupoFornecedor ? [idGrupoFornecedor] : (this.usuarioLogado.idsGrupoFornecedor || []);
      }
      const value = {
        tamanhoPagina: 0,
        idNivelExtensao: 3,
        idsExtensao: idsBusca,
        autocomplete: filtro,
      };
      return this.extensaoResources.listarAtivosComListaCnpj(value)
        .then((resultado) => {
          resultado.body.resposta.forEach((el) => {
            let nomGrupoFornecedor = el.id.toString().concat(' - ').concat(el.idExterno);
            if (this.isTenantEpoca) {
              nomGrupoFornecedor = el.idExterno.toString().concat(' - ').concat(el.nomExtensao);
            }
            const item = {
              ...el,
              id: el.id,
              nome: nomGrupoFornecedor,
              indPossuiRepresentacaoConjunto: el.indPossuiRepresentacaoConjunto,
            };
            this.gruposFornecedores.push(item);
            if (idGrupoFornecedor && idGrupoFornecedor.length) {
              idGrupoFornecedor.forEach((id) => {
                if (id === item.id) {
                  this.gruposFornecedoresSelecionados.push(item);
                }
              });
            }
          });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarUsuario(id) {
      this.usuarioResource.buscar({ id })
        .then((res) => {
          const usuario = res.body;
          this.indAtivoOriginal = usuario.indAtivo;
          const idsDosGrupos = usuario.idGrupoFornecedor ? usuario.idGrupoFornecedor.split(',').map((idGrupo) => Number(idGrupo.trim())) : [];
          this.buscarGruposFornecedores(idsDosGrupos).then(() => {
            this.editar(usuario);
            this.tenantsUsuario = usuario.tenant?.split(',').map((t) => t.trim()) ?? [];
            forceHideLoading();
          });
          this.buscarAceitesExistentes(id, idsDosGrupos);
        })
        .catch((err) => {
          this.$error(this, err);
          forceHideLoading();
        });
    },
    editar(usuario) {
      this.usuario = new Usuario();
      this.usuario.construirAPartirDaConsultaCompleta({ ...usuario });
      if (this.isConversao) {
        this.usuario.indAtivo = false;
        this.indAtivoOriginal = false;
        this.usuario.statusFluxo = null;
        this.usuario.indProcurador = false;
        this.usuario.dtaInicioVigencia = null;
        this.usuario.dtaFimVigencia = null;
        this.usuario.justificativaAprovacao = null;
        this.usuario.indUsuarioExternoMaster = true;
      }
      this.usuario.grupofornecedor = this.gruposFornecedoresSelecionados;
      this.gruposFornecedoresOriginais = [...this.gruposFornecedoresSelecionados];
      this.indTodosGruposPossuemAnexosCarregamentoPagina = usuario.indTodosGruposPossuemAnexos || false;
      this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.representante_legal');
      if (this.gruposFornecedoresSelecionados.length) {
        this.gruposFornecedoresSelecionados.forEach((el) => {
          this.$refs.usuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.incluirLinhaGrupoFornecedor(el.id);
        });
      }
      this.usuarioSemEdicao = copyObject(usuario);
      // Inicializar variáveis de controle de histórico de datas
      this.dtaInicioVigenciaOriginal = usuario.dtaInicioVigencia;
      this.dtaFimVigenciaOriginal = usuario.dtaFimVigencia;
    },
    limparFormulario() {
      this.usuario = new Usuario(null, 'FORNECEDOR');
      this.usuario.indUsuarioExternoMaster = true;
      this.usuario.tipoFornecedor = this.$t('label.tipos_fornecedor.representante_legal');
      this.encontrouOmni = false;
      this.buscouOmni = false;
      this.gruposFornecedoresOriginais = [];
      this.gruposFornecedoresSelecionados = [];
      this.gruposFornecedores = [];
      this.indTodosGruposPossuemAnexosCarregamentoPagina = false;
      this.tenantsUsuario = null;
      this.dtaInicioVigenciaOriginal = null;
      this.dtaFimVigenciaOriginal = null;
      this.dataApagada = false;
      this.$refs.form.reset();
    },
    cancel() {
      this.indCancelandoEdicao = true;
      this.limparFormulario();
      this.$router.push({ name: 'usuario-fornecedor' });
    },
    closeModal() {
      this.nomPerfilAprovador = '';
      this.nomUsuarioAprovador = '';
      this.dialogAcompanhamentoSemFluxo = false;
    },
    openCancelarDialog() {
      this.$refs.cancelarDialog.open();
    },
    todosOsGruposPossuemAnexos() {
      if (this.listaGrupoFornecedoresSelecionados.length === 0) {
        return true;
      }
      const refFilho = this.$refs.usuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm;
      const quantidadeAnexosPorGrupo = refFilho && refFilho.quantidadeAnexosPorGrupo
        ? refFilho.quantidadeAnexosPorGrupo
        : {};

      return this.listaGrupoFornecedoresSelecionados.every((grupo) => {
        const qtde = quantidadeAnexosPorGrupo[grupo.id];
        if (qtde !== undefined) {
          return qtde > 0;
        }
        const isGrupoOriginal = this.idsGruposOriginais.includes(grupo.id);
        if (isGrupoOriginal) {
          return this.indTodosGruposPossuemAnexosCarregamentoPagina;
        }
        return false;
      });
    },
    abrirAcompanhamento(usuario) {
      if (usuario.indAtivadoPeloAprovador) {
        this.nomPerfilAprovador = usuario.nomPerfilAprovador;
        this.nomUsuarioAprovador = usuario.nomUsuarioAprovador;
        this.dialogAcompanhamentoSemFluxo = true;
      } else {
        this.usuarioResource.buscarFluxoAprovacao({ idUsuario: usuario.id })
          .then((res) => {
            this.statusPassos = res.data;
            if (this.statusPassos.passos) {
              const passo = this.statusPassos.passos.find((e) => e.statusPasso === 'AGUARDANDO_APROVACAO');
              if (passo) {
                passo.isProximoPasso = true;
              }
            }
            setTimeout(() => this.$refs.modalAcompanhamento.open());
          })
          .catch((err) => {
            this.$toast(err.data.error);
          });
      }
    },
    abrirDocumentacao(grupo) {
      this.$refs.usuarioFornecedorDocumentacaoDialog.open(grupo);
    },
    abrirRepresentacaoConjunto(grupo) {
      this.$refs.usuarioFornecedorRepresentacaoConjuntoDialog.open(grupo);
    },
    buscarTermoAceite() {
      const param = { objetivo: 'CRIACAO_USUARIO_FORNECEDOR' };
      this.termoAceiteResources.buscarTermoPorObjetivo(param).then((resposta) => {
        this.termoAceite = resposta.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscarChaveFluxoRepresentanteLegal() {
      this.configSistemaResource.buscarChave({ chave: 'FLUXO_APROVACAO_USR_FORNE_REP_LEG' })
        .then((resp) => {
          this.indFluxoAprovacaoRepreLegal = resp.body;
        });
    },
    buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo() {
      this.configSistemaResource.buscarChave({ chave: 'DESABILITAR_FLUXO_APROVACAO_USUARIO_INATIVO' })
        .then((resp) => {
          this.desabilitaFluxoAprovacaoUsuarioInativo = resp.body;
        });
    },
    openModalAlteracaoData() {
      this.$refs.modalDataAlteracao.open();
    },
    desativarUsuario() {
      this.usuario.indAtivo = false;
    },
    cancelarEdicaoData() {
      this.usuario.dtaInicioVigencia = this.dtaInicioVigenciaOriginal;
      this.usuario.dtaFimVigencia = this.dtaFimVigenciaOriginal;
      this.$refs.usuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.restaurarDatasLocais();
    },
    setarPaginaCarregada(indPaginaCarregada) {
      this.isPaginaCarregada = indPaginaCarregada;
    },
  },
  beforeMount() {
    forceLoading();
    Promise.all([
      this.buscarTermoAceite(),
      this.buscarChaveFluxoRepresentanteLegal(),
      this.buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo(),
      this.buscarPerfis(),
      this.buscaDadosPerfilAprovador(),
    ]).then(() => {
      if (this.$route.params.id) {
        this.indCancelandoEdicao = false;
        this.idUsuario = parseInt(this.$route.params.id, 10);
        Promise.all([
          this.carregarUsuario(this.idUsuario),
          this.buscaTermoAceiteUsuarioCadastro(this.idUsuario),
          this.buscaDadosFluxosAprovacaoImpactados(this.idUsuario),
        ]).then(() => this.setarPaginaCarregada(true));
      } else {
        this.indCancelandoEdicao = false;
        this.usuario.indUsuarioExternoMaster = true;
        this.setarPaginaCarregada(true);
        forceHideLoading();
      }
    });
  },
};
</script>
<style scoped>
</style>
